<template>
  <v-tooltip :top='top' :left='left' :right='right' :bottom='bottom'>
    <template v-slot:activator="{ on }">
      <v-icon
        class='ml-1'
        small
        v-on='on'
        :color='iconColor'>
        mdi-archive
      </v-icon>
    </template>
    <span>{{ msg }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'wc-archived',
  props: {
    top: {
      required: false,
      default: true
    },
    left: {
      required: false,
      default: false
    },
    right: {
      required: false,
      default: false
    },
    bottom: {
      required: false,
      default: false
    },
    iconColor: {
      required: false,
      default: 'red'
    },
    msg: {
      required: false,
      default: 'Archived'
    }
  }
}
</script>
